import { render, staticRenderFns } from "./User_Author.vue?vue&type=template&id=908cfa6c&scoped=true"
import script from "./User_Author.vue?vue&type=script&lang=js"
export * from "./User_Author.vue?vue&type=script&lang=js"
import style0 from "./User_Author.vue?vue&type=style&index=0&id=908cfa6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908cfa6c",
  null
  
)

export default component.exports